import { styled } from 'next-yak';

import { createPolymorphicElement } from '@xing-com/polymorphic-element';
import { xdlColorTextSecondary } from '@xing-com/tokens';

import { BodyCopy } from '../';

// *** Components ***
const MetaElement = createPolymorphicElement(BodyCopy, ['lineHeight']);

const Meta = styled(MetaElement)`
  && {
    color: ${xdlColorTextSecondary};
  }
`;

export const Styled = {
  Meta,
};
